import { createApp } from 'vue'
import { isDesktop } from '~/js/templates/index/helpers'
import FProductCard from '~/js/components/productCard'
import FProductCardVertical from '~/js/components/productCard/vertical'
import { fetchVisibleCollectionProducts } from '~/js/helpers/storefront/collectionProducts'

const ID = 'js-snippetsCollectionRanking'
const PRODUCTS_LIMIT = 5
const PAGE_SIZE = 20

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById(ID)
  if (!element) return
  const collectionId = element.dataset.collectionId
  const storefrontAccessToken = element.dataset.storefrontAccessToken

  if (!storefrontAccessToken) return

  const fetchRankingProducts = async () => {
    return fetchVisibleCollectionProducts({
      collectionId,
      storefrontAccessToken,
      limit: PRODUCTS_LIMIT,
      pageSize: PAGE_SIZE,
    })
  }

  createApp({
    name: 'SnippetsCollectionRanking',
    data() {
      return {
        productsRanking: [],
        isDesktop: isDesktop(),
        isLoading: true,
      }
    },
    components: {
      FProductCard,
      FProductCardVertical,
    },
    computed: {
      productCardComponent() {
        return this.isDesktop ? 'FProductCard' : 'FProductCardVertical'
      },
    },
    async created() {
      try {
        this.productsRanking = await fetchRankingProducts()
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
        this.$nextTick(() => {
          window.zvRenderReviewSummary(element)
        })
      }
    },
  }).mount(element)
})
